const cadastro_causa_abandono = {
  path: "/cadastro-causa-abandono",
  redirect: "/cadastro-causa-abandono",
  meta: {
    breadCrumb: "Atendimento ao Aluno - Tabelas Auxiliares",
  },
  children: [
    {
      path: "/cadastro-causa-abandono",
      name: "cadastro-causa-abandono",
      component: () =>
        import("@/views/CadastroCausaAbandono/CadastroCausaAbandonoHome.vue"),
    },
    {
      path: "/cadastro-causa-abandono/novo",
      name: "cadastro-causa-abandono-novo",
      component: () =>
        import("@/views/CadastroCausaAbandono/CadastroCausaAbandonoCad.vue"),
    },
    {
      path: "/cadastro-causa-abandono/edit/:id",
      name: "cadastro-causa-abandono-edit",
      component: () =>
        import("@/views/CadastroCausaAbandono/CadastroCausaAbandonoEdit.vue"),
    },
    {
      path: "/cadastro-causa-abandono/delete/:id",
      name: "cadastro-causa-abandono-delete",
      component: () =>
        import("@/views/CadastroCausaAbandono/CadastroCausaAbandonoDelete.vue"),
    },
  ],
};

export { cadastro_causa_abandono };
